import { environment } from '../../../environments/environment';
var ProfileImageComponent = /** @class */ (function () {
    function ProfileImageComponent() {
        this.version = environment.API_VERSION;
        this.url = environment.API_BASE_URL;
    }
    Object.defineProperty(ProfileImageComponent.prototype, "id", {
        set: function (value) {
            if (value) {
                this.photo = this.url + "/" + this.version + "/files/" + value + "/download";
            }
            else {
                this.photo = undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProfileImageComponent.prototype, "file", {
        set: function (image) {
            if (image) {
                this.photo = this.url + "/" + this.version + "/files/" + image.id + "/download";
            }
            else {
                this.photo = undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    return ProfileImageComponent;
}());
export { ProfileImageComponent };
